import 'css-chunksrc/client/common/filterMenu/projectsTags/tag/styles.scss';export default {
  "tag": "_tag_14srl_1",
  "name": "_name_14srl_11"
};